import rpc from './rpc';
import { ShopService } from '../rpc/model/squareup/solidshop/v2/service/shop';

export default ShopService.create(rpc());
